import React from 'react';
import { createStyles, makeStyles, } from '@material-ui/core/styles';
import SearchInput from './SearchInput';
import { LoadingBounce } from '@michelin/acid-components';
import { isDark } from '../../../types/Theme';
var useStyles = makeStyles(function (theme) {
    var _a, _b;
    return createStyles({
        searbar: (_a = {
                zIndex: 10,
                width: '100%',
                backgroundColor: theme.palette.secondary.tint
            },
            _a[theme.breakpoints.down('xs')] = {
                flex: '0 0 45px',
            },
            _a[theme.breakpoints.up('sm')] = {
                flex: '0 0 52px',
            },
            _a),
        dark: {
            backgroundColor: theme.palette.background.paper,
            '& input': {
                color: 'white',
            },
        },
        closed: (_b = {},
            _b[theme.breakpoints.up('sm')] = {
                borderRadius: '0 0 6px 6px',
            },
            _b),
        loading: {
            pointerEvents: 'none',
            opacity: 0.2,
        }
    });
});
export default (function (_a) {
    var onSearchTerm = _a.onSearchTerm, isOpen = _a.isOpen, searchLoading = _a.searchLoading;
    var classes = useStyles();
    var dark = isDark();
    return (React.createElement("div", { className: "".concat(classes.searbar, " ").concat(dark ? classes.dark : '', " ").concat(!isOpen ? classes.closed : '', " ").concat(searchLoading ? classes.loading : '') },
        searchLoading &&
            React.createElement("div", { style: { position: 'absolute', paddingTop: '10px', width: '95%' } },
                React.createElement(LoadingBounce, null)),
        React.createElement(SearchInput, { onSearchTerm: onSearchTerm })));
});
//# sourceMappingURL=SearchBar.js.map